import { Col }from 'react-bootstrap';



interface ContentProps{
    image: string;
}

function SplashImage({image}: ContentProps){
    const style = ".dynamic-box { background-image: url('" + image +"'); }";
    return (
        <> 
                    <style>
                        {style}
                    </style>
                    <Col xs={{span:12}} className="px-0 bg-primary rectangle-image-block splash-image-block dynamic-box">
                    
                    </Col>


        </>
    )
}

export default SplashImage;